import { useEffect } from "react";
import { authAPI } from "../api/auth";
import { useLatestQuery } from "../api/useLatestQuery";

/** Counts open authenticated apps; hidden tabs may be throttled by the browser. */
export function PresenceHeartbeat() {
  const { data } = useLatestQuery(["authAPI.whoAmI"], () => authAPI.whoAmI({}));
  const authenticated = !!data?.ok && !!data?.userIdFromIdentityProvider && !!data?.hasCvpToken;
  useEffect(() => {
    if (!authenticated) return;
    let stopped = false;
    let timer: ReturnType<typeof setTimeout>;
    let pending = false;
    const beat = async () => {
      if (stopped || pending) return;
      pending = true;
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 10000);
      try {
        await fetch("/presence/heartbeat", { method: "POST", credentials: "include", cache: "no-store",
          headers: { "X-Wt-Presence": "1" }, signal: controller.signal });
      } catch { /* Telemetry must not interrupt normal portal use. */ }
      finally {
        clearTimeout(timeout);
        pending = false;
        if (!stopped) { clearTimeout(timer); timer = setTimeout(beat, 30000); }
      }
    };
    const resume = () => { if (document.visibilityState === "visible") { clearTimeout(timer); void beat(); } };
    void beat();
    document.addEventListener("visibilitychange", resume);
    return () => { stopped = true; clearTimeout(timer); document.removeEventListener("visibilitychange", resume); };
  }, [authenticated]);
  return null;
}
